const activeRequests = new Set();

export function composeBackendAbortSignals(primarySignal, externalSignal) {
  if (!externalSignal) {
    return { signal: primarySignal, cleanup: () => {} };
  }

  const controller = new AbortController();
  const abortCombined = () => controller.abort();
  const signals = [primarySignal, externalSignal];

  if (signals.some((signal) => signal?.aborted)) {
    controller.abort();
    return { signal: controller.signal, cleanup: () => {} };
  }

  signals.forEach((signal) => signal?.addEventListener('abort', abortCombined, { once: true }));
  return {
    signal: controller.signal,
    cleanup: () => {
      signals.forEach((signal) => signal?.removeEventListener('abort', abortCombined));
    },
  };
}

/**
 * Register one backend request with the current authenticated browser session.
 * The returned AbortSignal lets logout terminate the underlying fetch, while
 * finish() removes completed requests from session cancellation.
 */
export function beginBackendRequest() {
  const controller = new AbortController();

  if (typeof window === 'undefined') {
    return {
      signal: controller.signal,
      finish: () => {},
    };
  }

  activeRequests.add(controller);
  const finish = () => {
    activeRequests.delete(controller);
  };
  return { signal: controller.signal, finish };
}

/**
 * Establish a hard logout boundary by aborting all pending session requests.
 */
export function cancelPendingBackendRequests() {
  const pendingRequests = Array.from(activeRequests);
  activeRequests.clear();
  pendingRequests.forEach((controller) => controller.abort());
}
